module.exports = __webpack_public_path__ + "img/vertical_2_1_1.61da8c71.png";